import http from "helpers/http.js";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Submit a game rating
 * @param {string} uniqueId - Unique visitor ID from localStorage
 * @param {string} userEmail - User email if logged in, null otherwise
 * @param {number} rating - Star rating 1-5
 * @param {string} roomId - Current room ID
 * @param {number} gamesPlayed - Number of games played in session
 * @param {string} platform - Platform (web, firetv, etc.)
 * @returns {Promise<Object>} Response with ratingId
 */
const submitRating = (uniqueId, userEmail, rating, roomId, gamesPlayed, platform) => {
    var config = {
        method: 'post',
        url: API_URL + 'api/Authenticate/submit-rating',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            uniqueId,
            userEmail,
            rating,
            roomId,
            gamesPlayed,
            platform
        }
    };

    return http(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
            return error.response?.data || { Status: "Error", Message: "Failed to submit rating" };
        });
};

/**
 * Update rating with feedback text
 * @param {number} ratingId - ID of the rating to update
 * @param {string} feedback - Feedback text
 * @returns {Promise<Object>} Success or error response
 */
const updateRatingFeedback = (ratingId, feedback) => {
    var config = {
        method: 'put',
        url: API_URL + 'api/Authenticate/update-rating-feedback/' + ratingId,
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            feedback
        }
    };

    return http(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
            return error.response?.data || { Status: "Error", Message: "Failed to update feedback" };
        });
};

export default {
    submitRating,
    updateRatingFeedback
};
